var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6584 5.00024C13.6596 4.36116 12.4722 3.99072 11.1981 3.99072H10.3426C6.79179 3.99072 3.91482 6.86769 3.91482 10.4185V14.3629C2.25678 14.6582 1 16.1043 1 17.838V18.315C1 20.2683 2.58233 21.8506 4.53564 21.8506H17.005C18.9583 21.8506 20.5407 20.2683 20.5407 18.315V17.838C20.5407 16.0967 19.2839 14.6506 17.6258 14.3629V11.5002",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94141 4.14195V2.8246C8.94141 1.81766 9.75907 1 10.766 1C11.7729 1 12.5906 1.81766 12.5906 2.8246V4.14195",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5828 21.8579V23.1753C12.5828 24.1822 11.7651 24.9999 10.7582 24.9999C9.75126 24.9999 8.93359 24.1822 8.93359 23.1753V21.8579",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 7.5,
    r: 3.5,
    fill: "#E34919",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmActive);
export default __webpack_public_path__ + "static/media/AlarmActive.39d611fa99e39907a0cff1c63d8b1811.svg";
export { ForwardRef as ReactComponent };